import { DateTime } from 'luxon'

const appURL = process.env.CFH_APP_URL
const timeNow = DateTime.local().toISODate()

const getCFHLiveUrl = (id: string, eventSlug: string, endsAt: string) => {
  return appURL && timeNow > endsAt ? `${appURL}/${eventSlug}/schedule/${id}` : ''
}

export default getCFHLiveUrl
